import {Alarm} from "../entities/Alarm";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class AlarmService extends BaseService<Alarm>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Alarm);
    }
    protected getBaseUrl():string{
        return "alarm";
    }
}
